import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { ContactService } from '../../contact.service';

@Component({
  selector: 'app-cert-option',
  templateUrl: './cert-option.component.html',
  styleUrls: ['./cert-option.component.scss']
})
export class CertOptionComponent implements OnInit {
  dataobject: any;

  constructor(public dialogRef: MdDialogRef<CertOptionComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,public dialog: MdDialog,private contactService: ContactService) {
      console.log(data);
      this.dataobject = data;
     }
  ngOnInit() {
  }
  
  basic(){
    this.dialogRef.close('basic');
  }

  advance(){
    this.dialogRef.close('advance');
 
  }
}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/device/cert-option/cert-option.component.ts